import {System} from 'common/models/system';

import {RootState} from '../..';
import initialState from '../constants/initialState';

const selectSystem: (state: RootState) => System = (state) => state.system || initialState;

export default selectSystem;
